/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFieldDestroy } from '../../axios/customFieldDestroy'
import type {
	CustomFieldDestroyError,
	CustomFieldDestroyPathParams,
	CustomFieldDestroyResponse,
} from '../../types/CustomFieldDestroy'

export const customFieldDestroyMutationKey = () => [{ url: '/:organisation/custom_fields/:field' }] as const

export type CustomFieldDestroyMutationKey = ReturnType<typeof customFieldDestroyMutationKey>

export type CustomFieldDestroyVariables = {
	organisation: CustomFieldDestroyPathParams['organisation']
	field: CustomFieldDestroyPathParams['field']
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::destroy */
export function useCustomFieldDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CustomFieldDestroyResponse,
		AxiosError<CustomFieldDestroyError>,
		CustomFieldDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customFieldDestroyMutationKey(),
		mutationFn: ({ organisation, field }: CustomFieldDestroyVariables) =>
			customFieldDestroy(organisation, field, config).then(res => res.data),
		...options,
	})
}
